const initializeHeaderNavSp = () => {
  const headerNavEl = document.querySelector(".fs-header-nav-sp");
  addSpSubmenuEvents(headerNavEl);
  addSpScrollEvents(headerNavEl);
};

const addSpSubmenuEvents = (headerNavEl) => {
  headerNavEl.querySelectorAll("nav .fs-nav-item.has-submenu").forEach((navItem) => {
    const button = navItem.querySelector("button");
    button.addEventListener("click", () => {
      const submenu = navItem.querySelector(".fs-submenu");
      if (submenu.classList.contains("show")) {
        hideAllSubmenus(headerNavEl);
      } else {
        hideAllSubmenus(headerNavEl);
        const viewportHeight = window.visualViewport?.height || document.documentElement.clientHeight;
        const rect = navItem.getBoundingClientRect();
        submenu.style.top = `${rect.y + rect.height - 4}px`;
        submenu.style.height = `${viewportHeight - rect.y - rect.height + 4}px`;
        submenu.scrollTo(0, 0);
        submenu.classList.add("show");

        button.classList.add("active");
      }
    });
    const parentItems = navItem.querySelectorAll(".fs-submenu-collections .fs-submenu-item.parent");
    parentItems.forEach((parentItem) => {
      parentItem.querySelector("button").addEventListener("click", (event) => {
        event.stopPropagation();
        event.preventDefault();
        parentItem.classList.toggle("open");
      });
    });
  });
};

const addSpScrollEvents = (headerNavEl) => {
  const container = headerNavEl.querySelector(".fs-nav-items-container");
  if (container) {
    container.addEventListener("scroll", () => {
      hideAllSubmenus(headerNavEl);
    });
  }
};

const hideAllSubmenus = (headerNavEl) => {
  headerNavEl.querySelectorAll(".fs-nav-item.has-submenu .fs-submenu").forEach((submenu) => {
    submenu.classList.remove("show");
  });
  headerNavEl.querySelectorAll(".fs-nav-item-trigger").forEach((el) => {
    el.classList.remove("active");
  });
};

/*
 * Main
 */

const headerNavSpMain = () => {
  initializeHeaderNavSp();
};

addEventListener("DOMContentLoaded", (event) => {
  headerNavSpMain();
});
